module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n9r7n4n-0445a8fa0e8d120dd0a01119e2090182.svg";